<template>
  <div class="customer layout mobile" id="mobile" :class="mainColor">
    <div class="main page-main">
      <router-view></router-view>
    </div>
    <evaluate-page />
    <loading v-if="isload" />
    <!-- 通知 -->
    <el-dialog
      title="维护通知"
      :visible.sync="SysNotice"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      top="20vh"
      width="80%"
      center
    >
      <span style="white-space: pre-line;line-height:1.5">{{
        domain && domain.NOTICE_URL
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的，我知道了</el-button>
      </span>
    </el-dialog>

    <!--  开启了多个窗口-->
    <el-dialog
      title="请在最新的标签查看"
      :visible="isShowWinTagClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      top="20vh"
      width="50%"
      center
    >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的，我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import reconnect from "src/mixins/reconnect";
import unloadEvent from "src/mixins/unloadEvent";
import refreshAndClose from "src/mixins/refreshAndClose";
import popstateEvent from "src/mixins/popstateEvent";
import loading from "../../../components/loading/loading";
import utils from "../utils";
import eruda from "eruda";

// import service from "src/app/customer/service";
// import store from "../store";
export default {
  name: "app",
  mixins: [reconnect, unloadEvent, refreshAndClose, popstateEvent],
  computed: {
    ...mapState(["isload", "mainColor", "SysNotice", "domain"]),
    ...mapState({
      isShowWinTagClose: state => state.modal.isShowWinTagClose
    })
  },
  components: {
    loading
  },
  data() {
    return {};
  },
  methods: {
    close() {
      utils.closePage();
      this.$store.commit("setState", {
        SysNotice: false
      });
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function(event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
    if (process.env.NODE_ENV == "development") {
      eruda.init();
    }
  }
  // created() {
  //   service.queryServerConfig().then(res => {
  //     if (res) {
  //       if (res.code == 200 && res.data) {
  //         sessionStorage.setItem("serverTime", res.data.dateTime);
  //       }
  //     }
  //   });
  // },
};
</script>
<style>
.el-message-box {
  width: 350px;
}
html,
body {
  scroll-behavior: smooth !important;
}
body {
  height: 100%;
  width: 100vw;
}
</style>
<style scoped lang="less">
.customer {
  display: flex;
  flex-direction: column;
  height: 100%;

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    overflow: hidden;
    // background-color: #f3f3f3;
  }
}
</style>
